<script lang="ts">
	export let width: number
	export let boxText: string
	export let boxLink: string
	export let colour: 'RED' | 'BLUE' | 'WHITE'
</script>

<div class="col-span-{width}">
	<a
		href={boxLink}
		class="btn-new"
		class:btn-new-red={colour === 'RED'}
		class:btn-new-blue={colour === 'BLUE'}>{boxText}</a
	>
</div>
